import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Avatar, Typography, Button } from '@material-ui/core';
import cv from '../images/cv.JPG'
import doc from '../images/184142r.pdf'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        paddingTop: '2%',
        backgroundColor: '#022744',
        minHeight: '45vw'
    },
    control: {
        padding: theme.spacing(4),
    },
    image: {
        width: theme.spacing(35),
        height: theme.spacing(35),
        margin: theme.spacing(1),
        borderRadius: '50%'
    },
    title: {
        color: "white"
    },
    line1: {
        width: '60%',
        height: '3px',
        background: 'linear-gradient(to bottom right, purple, white)',
        "@media (max-width: 900px)": {
            width: '90%',
            height: '3px',
        }
    },
    line2: {
        width: '20%',
        height: '3px',
        background: 'linear-gradient(to bottom right, purple, white)',
        marginBottom: '10px',
        "@media (max-width: 900px)": {
            width: '45%',
            height: '3px',
        }
    },
    about: {
        color: 'white',
        textAlign: 'justify',
        marginBottom: "40px"
    },
    experience: {
        color: 'white',
        textAlign: 'justify'
    },
    button: {
        marginTop: '40px'
    },
    para: {
        margin: '25px',
    },
    link: {
        color: "white",
        textDecoration: "none",
        '&:hover': {
            color: "white",
            textDecoration: "none",
        },
    },
    experienceTitle: {
        color: "silver"
    }
}));

export default function Resume2() {
    const classes = useStyles();

    return (
        <Grid container className={classes.root} spacing={2}>
            <Grid item xs={12}>
                <Grid container justify="center" spacing={2}>
                    <Grid item sm={12} md={3}>
                        <Avatar className={classes.image} src={cv} alt="Mohamed Razan" />
                        <Typography className={classes.title} variant="h4">
                            Mohamed Razan
                        </Typography>
                        <Typography className={classes.title} variant="h6">
                            Developer
                        </Typography>
                        <div className={classes.line1} />
                    </Grid>
                    <Grid item sm={12} md={8} className={classes.para}>
                        <Typography className={classes.title} variant="h4">
                            About Me
                        </Typography>
                        <div className={classes.line2} />
                        <Typography className={classes.about}>
                            I am a passionate, hardworking and tech enthusiastic undergraduate
                            with a good knowledge of programming languages and development tools,
                            having an open mind about learning new things and working on difficult
                            areas. I am passionate about training to become a software engineer. I’m
                            reading for B.Sc. (Hons) in Information technology at University of Moratuwa
                            and I am with an overall CGPA of 3.82. I have experienced many coding
                            competitions and have developed some web applications. Also I am interested
                            in Algorithms and problem solving. My  aim is to be a “Full-stack web developer”
                            and as a “Mobile app developer”. I’m enhancing my knowledge on these fields
                            and hope to learn from experts, work in teams and do a quality job of any works
                            assigned to me.
                        </Typography>

                        <Typography className={classes.title} variant="h4">
                            Professional Experience
                        </Typography>

                        <div className={classes.line2} />
                            <Typography className={classes.experienceTitle} variant="h6">
                                CodeGen International (Pvt) Ltd | 2022 Jan - 2022 July
                            </Typography>
                        <Typography className={classes.experience}>
                            I am a passionate, hardworking and tech enthusiastic undergraduate
                            with a good knowledge of programming languages and development tools,
                            having an open mind about learning new things and working on difficult
                            areas. I am passionate about training to become a software engineer. I’m
                            reading for B.Sc. (Hons) in Information technology at University of Moratuwa
                            and I am with an overall CGPA of 3.82. I have experienced many coding
                            competitions and have developed some web applications. Also I am interested
                            in Algorithms and problem solving. My  aim is to be a “Full-stack web developer”
                            and as a “Mobile app developer”. I’m enhancing my knowledge on these fields
                            and hope to learn from experts, work in teams and do a quality job of any works
                            assigned to me.
                        </Typography>
                        <Button variant="contained" color="primary" className={classes.button}>
                            <a href={doc} download="cv.pdf" className={classes.link}>
                                download cv
                            </a>
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
